import { render, staticRenderFns } from "./shopGroup.vue?vue&type=template&id=89a5a4fe&scoped=true&"
import script from "./shopGroup.vue?vue&type=script&lang=js&"
export * from "./shopGroup.vue?vue&type=script&lang=js&"
import style0 from "./shopGroup.vue?vue&type=style&index=0&id=89a5a4fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a5a4fe",
  null
  
)

export default component.exports